import React from 'react';
import { MembersAvatars } from '@tribeplatform/react-components/MembersAvatars';
export const MembersAvatarsBlock = ({ ids, moreCount, }) => {
    if (!ids) {
        return null;
    }
    return React.createElement(MembersAvatars, { ids: ids, moreCount: moreCount });
};
//# sourceMappingURL=Block.js.map